import React from 'react'
import { Layout, Button, Image } from 'antd'
import { DownloadOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom'
import logoImg from "./logo.png"

const { Header } = Layout
export default function TopHeader() {
    const navigate = useNavigate();
    const buttonSize = 'large'
    return (
        <Header style={{
            overflow: 'auto',
            width: '100vw',
            position: 'fixed',
            left: 0,
            top: 0,
            bottom: 0,
            right: 0,
          }}>
  
            <div className="top-left">
                <div className="top-left"><Image width={40} src={logoImg}/></div>
                <div className="logo">&nbsp;朗维道路</div>
            </div>
            <div className="top-right">
                <a href="http://letwego.com.cn/Software/lwg.zip" download><Button type="primary" icon={<DownloadOutlined/>} size={buttonSize}>专业版</Button></a>
                &nbsp;
                <a href="http://letwego.com.cn/Software/lwg.txt" download><Button type="primary" icon={<DownloadOutlined/>} size={buttonSize}>体验版</Button></a>
            </div>
        </Header>
    )
}
